export class UnauthorizedError extends Error {
    showError;
    constructor(message) {
        super(message);
        this.name = 'UnauthorizedError';
    }
}
//# sourceMappingURL=errors.js.map